export default __webpack_public_path__ + "static/media/filter.4f06adb4.svg";